module.exports = __webpack_public_path__ + "static/img/Inspection12.9d96b2ef.png";